import { PageHero, SoftLink } from "@/components/ui/PageHero";
import { MOTOKO_MAKER_LOGO, ROUTES } from "@/lib/routes";
import { Link } from "react-router-dom";
import { useGetPublicGovernanceProposals } from "@/hooks/usePublicProtocol";
import { AnimatedSection } from "@/components/layout/AnimatedSection";

export default function MotokoMakerPage() {
	const { data } = useGetPublicGovernanceProposals();
	const proposals = (data?.proposals ?? []).slice(0, 3);

	return (
		<div className="pb-16">
			<PageHero
				eyebrow="MotokoMaker · $MMK"
				title="Governance token"
				subtitle="Get & stake MMK for vote weight. MMK enters via USDM→MMK only-up swap — not the other way."
				actions={
					<>
						<SoftLink to={ROUTES.governance}>Open Governance</SoftLink>
						<img
							src={MOTOKO_MAKER_LOGO}
							alt=""
							className="ml-auto hidden size-14 object-contain sm:block"
						/>
					</>
				}
			/>
			<div className="container mx-auto grid gap-4 px-4 md:grid-cols-2">
				<AnimatedSection className="glass-panel p-5">
					<p className="section-eyebrow">
						Latest proposals · {data?.source ?? "…"}
					</p>
					<ul className="mt-3 space-y-2">
						{proposals.length === 0 ? (
							<li className="text-sm text-muted-foreground">
								No proposals yet — create one under Governance.
							</li>
						) : (
							proposals.map((p) => (
								<li key={p.id}>
									<Link
										to={ROUTES.governance}
										className="block rounded-xl border border-border/50 px-3 py-2 text-sm hover:border-primary/40"
									>
										#{p.id} · {p.title}
									</Link>
								</li>
							))
						)}
					</ul>
				</AnimatedSection>
				<AnimatedSection className="glass-panel space-y-3 p-5">
					<p className="section-eyebrow">Get & stake</p>
					<p className="text-sm text-muted-foreground">
						Live buy-on-curve, stake, and vote live under Governance (not a demo
						toast).
					</p>
					<Link
						to={`${ROUTES.governance}?tab=stake`}
						className="inline-flex h-11 w-full items-center justify-center rounded-xl bg-primary text-sm font-semibold text-primary-foreground"
					>
						Open Governance · stake MMK
					</Link>
				</AnimatedSection>
			</div>
		</div>
	);
}